import React, { useContext } from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface CannotUpdateDriverPerformanceModalProps {
  // data?: any;
}

const CannotUpdateDriverPerformanceModal: React.FC<
  CannotUpdateDriverPerformanceModalProps
> = () => {
  const modalContext = useContext(ModalContext);
  const { name: driverName } = useParams();

  return (
    <ModalContainer label='Unable to update performance'>
      <Message>
        You cannot submit a report for {driverName} because this driver has not
        been assigned to any vehicle.
      </Message>
      <ButtonArea>
        <FormSubmitButton
          className='clear fill'
          onClick={() => modalContext?.setShowModal(false)}
          btnType='button'
        >
          Cancel
        </FormSubmitButton>
        <FormSubmitButton
          onClick={() => modalContext?.setShowModal(false)}
          className='fill'
          btnType='button'
        >
          Done
        </FormSubmitButton>
      </ButtonArea>
    </ModalContainer>
  );
};

const Message = styled.div`
  /* margin: 32px 0 40px 0; */
  font-size: 14px;
  color: #6b7280;
`;

const ButtonArea = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export default CannotUpdateDriverPerformanceModal;
